<template>
  <v-app light>
    <v-container fluid class="default-view">
        <transition name="page" mode="out-in">
            <router-view :key="$route.fullPath"></router-view>
        </transition>
    </v-container>
    <feedback-message></feedback-message>
  </v-app>
</template>

<script>
import FeedbackMessage from '~/components/FeedbackMessage'

export default {
  name: 'default-layout',
  components: {
    'feedback-message': FeedbackMessage
  }
}
</script>
<style scoped>
.theme--light.v-application {
    background: #78B943;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue